import { CHANGE_APPLICANT_TYPE, SELECT_CHILD } from '../constants';

export const changeApplicantType = payload => ({
  type: CHANGE_APPLICANT_TYPE,
  payload
});
export const selectChild = payload => ({ type: SELECT_CHILD, payload });

export default changeApplicantType;
